import axios, { AxiosRequestConfig } from 'axios';
import { STORAGE_KEYS } from 'utils/constants';

const BASE_API_URL = process.env.REACT_APP_BRAND_API_URL;
const BASE_API_KEY = process.env.REACT_APP_API_KEY;

interface ApiServiceOptions extends AxiosRequestConfig {
  useToken?: boolean;
  isInternal?: boolean;
}

const getToken = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  return token;
};

const makeRequest = <T>(urlPath: string, options: ApiServiceOptions) => {
  const { useToken = true, isInternal, baseURL, ...otherOptions } = options;
  const headers = options?.headers ?? {};
  if (isInternal) headers['x-api-key'] = BASE_API_KEY;
  if (useToken) headers['Authorization'] = 'Bearer ' + getToken();
  const fullUrl = `${baseURL ?? BASE_API_URL}${urlPath}`;
  return axios.request<T>({ ...otherOptions, url: fullUrl, headers });
};

export const apiService = {
  get: <T = any>(urlPath: string, options: ApiServiceOptions = {}) =>
    makeRequest<T>(urlPath, { method: 'get', ...options }),
  patch: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'patch', ...options }),
  post: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'post', ...options }),
  put: <T = any>(urlPath: string, options: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'put', ...options }),
  delete: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'delete', ...options })
};
